















































































































































































































































import Vue from 'vue'
import AbpBase from '../../../lib/abpbase'
import { Component } from 'vue-property-decorator'
import OrderApi from '@/api/order/list'
import ShippingCompany from '@/api/shipping/index'
import CustomForm from '@/components/custom-form/index.vue'
import areaList from '@/lib/area'
import newCategorySelect from '@/components/newCategory-select/newIndex.vue'
import GoodsApi from '@/api/goods/list'
@Component({
  components: {
    CustomForm,
    newCategorySelect
  },
})
export default class OrderDetails extends AbpBase {
  editPayAmountModal = false
  loadChangePayAmountModal = false
  editProductCount: boolean = false
  isClearFilter: boolean = false
  newPayAmount = 0
  newProductCount: number = 1
  selectChangeCountObj: any = {}
  categoryOptions: any[] = []
  stepList: any[] = [
    { title: '提交订单', content: '' },
    { title: '支付订单', content: '' },
    // { title: '平台发货', content: '' },
    { title: '已完成', content: '' },
    // { title: '已评价', content: '' },
  ]
  currentStep = 1
  columnsBasicinfo: any[] = [
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '订单类型',
      key: 'orderType',
      align: 'center',
    },
    {
      title: '订单总额',
      key: 'orderTotal',
      align: 'center',
    },
    {
      title: '折扣金额',
      key: 'discountAmount',
      align: 'center',
    },
    {
      title: '配送费',
      key: 'shippingFee',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  columnsProductinfo: any[] = [
    {
      title: '商品图片',
      slot: 'pictureUrl',
      align: 'center',
    },
    {
      title: '商品名称',
      slot: 'productName',
      align: 'center',
    },
    {
      title: '价格/货号',
      slot: 'price',
      align: 'center',
    },
    {
      title: '属性',
      key: 'skuName',
      align: 'center',
    },
    {
      title: '优惠后单价',
      key: 'promotionPrice',
      align: 'center',
    },
    {
      title: '数量',
      key: 'quantity',
      slot: 'quantity',
      align: 'center',
    },
    {
      title: '库存',
      key: 'storeStockQuantity',
      align: 'center',
    },
    {
      title: '箱规',
      key: 'productBoxRule',
      align: 'center',
    },
    {
      title: '月销',
      key: 'salesMonthCount',
      align: 'center',
    },
    // {
    //   title: '包裹名',
    //   key: 'packages',
    //   align: 'center',
    // },
    {
      title: '小计',
      slot: 'subTotal',
      align: 'center',
    },
  ]
  packagesColumns: any[] = [
    {
      title: '包裹名',
      key: 'packageName',
      align: 'center',
    },
    {
      title: '发货时间',
      slot: 'deliveryTime',
      align: 'center',
    },
    {
      title: '快递公司名称',
      slot: 'expressCompanyName',
      align: 'center',
    },
    {
      title: '快递单号',
      slot: 'shipmentNumber',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  columnsUserinfo: any[] = [
    {
      title: '收货人',
      key: 'name',
      align: 'center',
    },
    {
      title: '手机号码',
      key: 'phone',
      align: 'center',
    },
    {
      title: '邮政编码',
      key: 'zipCode',
      align: 'center',
    },
    {
      title: '省市区',
      slot: 'province',
      align: 'center',
    },
    {
      title: '收货地址',
      key: 'address',
      align: 'center',
    },
  ]

  shipmentList: any[] = []
  giftCare: any[] = []
  columnsPriceinfo: any[] = [
    {
      title: '项目',
      slot: 'couponName',
      align: 'center',
    },
    {
      title: '优惠/费用',
      slot: 'promotionAmount',
      align: 'center',
    },
  ]
  columnsActioninfo: any[] = [
    {
      title: '操作人账号',
      key: 'userName',
      align: 'center',
    },
    {
      title: '操作时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '订单状态',
      key: 'orderStatus',
      align: 'center',
    },
    // {
    //   title: '付款状态',
    //   key: 'paymentStatus',
    //   align: 'center',
    // },
    {
      title: '发货状态',
      key: 'shippingStatus',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  editModal = false
  orderDetail: any = {}
  validatePhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('手机号不能为空'))
    } else if (!/^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/.test(value)) {
      callback('手机号格式不正确')
    } else {
      callback()
    }
  }
  addressForm = [
    {
      label: '收货人姓名：',
      type: 'input',
      rule: { required: true, message: '请输入收货人姓名', trigger: 'blur' },
      key: 'name',
    },
    {
      label: '手机号码：',
      type: 'input',
      rule: { required: true, validator: this.validatePhone, trigger: 'blur' },
      key: 'phone',
    },
    {
      label: '邮政编码：',
      type: 'input',
      rule: { required: true, message: '请输入邮政编码', trigger: 'blur' },
      key: 'zipCode',
    },
    {
      label: '所在区域：',
      type: 'cascader',
      rule: {
        type: 'array',
        min: 2,
        required: true,
        message: '请选择所在区域',
        trigger: 'change',
      },
      defaultValue: [],
      key: 'area',
      options: areaList,
    },
    {
      label: '详细地址：',
      key: 'address',
      rule: { required: true, message: '请输入详细地址', trigger: 'blur' },
      renderContent: (h, item, form, _this) => {
        let $input = h('i-input', {
          props: {
            value: form['address'],
            type: 'textarea',
            autosize: { minRows: 6, maxRows: 10 },
          },
          style: {
            width: '240px',
          },
          ref: 'address',
          on: {
            input: (value) => {
              form['address'] = value
            },
          },
        })
        return h('div', [$input])
      },
    },
  ]
  orderNoteList = []
  loadModal = false
  get addressList() {
    let list = []
    if (this.orderDetail.shippingAddress) {
      list.push(this.orderDetail.shippingAddress)
    }
    return list
  }

  get basicInfo() {
    let list = []
    if (this.orderDetail) {
      list.push(this.orderDetail)
    }
    return list
  }

  get orderItems() {
    return this.orderDetail.orderItems ? this.orderDetail.orderItems : []
  }

  get expressPackages() {
    return this.orderDetail.expressPackages ? this.orderDetail.expressPackages : []
  }

  created() {
    if (this.$route.query['id']) {
      this.getOrderDetail()
      this.getOrderNote()
    }
    // this.getCategoriesAll()
    this.getShippingCompanyList()
  }
  gotoVipDetail() {
    this.$router.push({
      name: 'vipDetail',
      query: {
        id: this.orderDetail.creatorId,
      },
    })
  }
  /**
   * 获取商品分类
   */
  async getCategoriesAll() {
    await GoodsApi.getCategoriesAll(null).then((res) => {
      if (res.data.items) {
        this.categoryOptions = res.data.items
      }
    })
  }
  onCategoryChange(selectedClassifyList) {
    OrderApi.filterOrderItemsById(this.$route.query.id.toString(), selectedClassifyList).then(res => {
      this.orderDetail.orderItems = res.data
      this.isClearFilter = false
    })
  }
  clearFilter() {
    this.isClearFilter = true
    this.getOrderDetail()
  }
  /**
   * 获取物流公司列表
   */
  getShippingCompanyList() {
    ShippingCompany.getShippingCompanyList().then((res) => {
      this.shipmentList = res.data.items
    })
  }
  changeProductCount(row) {
    console.log(row)
    this.editProductCount = true
    this.selectChangeCountObj = row
    this.newProductCount = row.quantity
  }
  changeProductCountSure() {
    console.log(this.newProductCount);
    OrderApi.changeOrderItemCount(this.selectChangeCountObj.id, this.newProductCount).then(res => {
      this.$Notice.success({
        desc: '修改成功'
      })
      this.editProductCount = false
      this.getOrderDetail()
    })
  }
  /**
   * 订单详情
   */
  getOrderDetail() {
    let id = this.$route.query['id'].toString()
    OrderApi.orderDetail(id).then((res) => {
      // res.data.expressPackages.forEach((item) => {
      //   res.data.orderItems.forEach((child) => {
      //     if (item.orderItemIdArray.indexOf(child.id) > -1) {
      //       child['packages'] = item.packageName
      //       child['_disabled'] = true
      //     }
      //   })
      // })
      this.orderDetail = res.data
      this.currentStep = res.data.orderFullStatus + 1
      if (res.data.reviewStatus) {
        this.currentStep = 5
      }
      this.giftCare = res.data.promotions
      this.stepList[0].content = this.orderDetail.creationTime
      this.stepList[1].content = this.orderDetail.payTime
      // this.stepList[2].content = this.orderDetail.deliveryTime
      this.stepList[2].content = this.orderDetail.receivedTime
      // this.stepList[4].content = this.orderDetail.reviewTime
    })
  }

  /**
   * 获取订单操作日志
   */
  getOrderNote() {
    let id = this.$route.query['id'].toString()
    OrderApi.getOrderNote(id).then((res) => {
      this.orderNoteList = res.data.items
    })
  }

  /**
   * 修改收货人信息
   */
  updateUserAddress() {
    let $form: any = this.$refs.formEdit
    $form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      let obj = {
        name: form.name,
        phone: form.phone,
        province: form.area[0],
        city: form.area[1],
        district: form.area[2],
        address: form.address,
        zipCode: form.zipCode,
      }
      let id = this.$route.query['id'].toString()
      this.loadModal = true
      OrderApi.updateUserAddress(id, obj)
        .then((res) => {
          this.$Notice.success({
            title: '修改成功',
          })
          this.loadModal = false
          this.editModal = false
          this.getOrderDetail()
        })
        .catch((err) => {
          this.loadModal = false
        })
    }
  }
  showChangePayAmount() {
    this.editPayAmountModal = true
  }
  updatePayAmount() {
    this.loadChangePayAmountModal = true
    OrderApi.updatePayAmount({
      orderId: this.orderDetail.id,
      payAmount: this.newPayAmount,
    }).then((res) => {
      this.$Message.success('修改成功')
      this.loadChangePayAmountModal = false
      this.editPayAmountModal = false
      this.getOrderDetail()
      this.getOrderNote()
    })
  }
  showAddress() {
    this.addressForm.forEach((item) => {
      if (item.key == 'area') {
        // iview 级联赋值问题
        item.defaultValue = [
          this.orderDetail.shippingAddress.province,
          this.orderDetail.shippingAddress.city,
          this.orderDetail.shippingAddress.district,
        ]
      }
    })
    this.editModal = true
    setTimeout(() => {
      if (this.orderDetail.shippingAddress) {
        let $form: any = this.$refs.formEdit
        let obj = {
          name: this.orderDetail.shippingAddress.name,
          phone: this.orderDetail.shippingAddress.phone,
          zipCode: this.orderDetail.shippingAddress.zipCode,
          address: this.orderDetail.shippingAddress.address,
        }
        $form.setForm(obj)
      }
    }, 10)
  }

  cancelAddress() {
    this.editModal = false
  }

  /**
   * 更新包裹快递信息
   */
  updatePackages(row) {
    if (!row.expressCompanyName) {
      this.$Modal.error({
        title: '请选择快递公司',
      })
      return
    }
    if (!row.shipmentNumber) {
      this.$Modal.error({
        title: '请输入快递单号',
      })
      return
    }
    let orderId = this.$route.query['id'].toString()
    this.$Modal.confirm({
      title: '提示',
      content: `确认更新包裹信息？`,
      onOk: () => {
        OrderApi.updatePackages(orderId, row.id, row.expressCompanyName, row.shipmentNumber).then((res) => {
          this.$Notice.success({ desc: '更新成功' })
          this.getOrderDetail()
          this.getOrderNote()
        })
      },
    })
  }

  logisticsTrackingFn() {
    this.$router.push({
      name: 'logisticsTracking',
      query: {
        id: this.orderDetail.id,
      },
    })
  }
}
